function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.292,
  width: 17.833,
  height: 17.833,
  rx: 2.675,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.885 3.566L8.188 9.32l-4.33 4.678h.975l3.79-4.095 3.064 4.095h3.317l-4.546-6.077 4.031-4.355h-.975L10.023 7.34 7.202 3.566H3.885zm1.433.718h1.524l6.728 8.996h-1.523L5.318 4.284z",
  fill: "#fff"
});

function SvgXBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgXBlack;